import React, {useState, useEffect} from 'react';

import {retrieveAllGrants} from "../../../../services/GrantService";
import {Table} from "../../../common/table/Table";

export const GrantTable = ({context, setContext, navigateTo, setSpinnerText, showToaster}) => {
    const [grantList, setGrantList] = useState([]);

    useEffect(() => {
        const fetchGrants = async () => {
            setSpinnerText("Retrieving Grants");
            const [data, error] = await retrieveAllGrants(context.username);
            if (data) {
                if (data.responseStatus === "Success") {
                    setGrantList(data.grantVOS);
                } else {
                    showToaster(data);
                }
            } else {
                showToaster({
                    responseStatus: "Error",
                    responseMessage: error.message,
                });
            }
            setSpinnerText(null);
        }
        fetchGrants();
    }, []);


    const handleAddClick = () => {
        setContext((prevState) => ({
            ...prevState,
            selectedGrant: null,
        }));
        navigateTo("grantCapture");
    }

    const handleRowClick = (grant) => {
        setContext((prevState) => ({
            ...prevState,
            selectedGrant: grant,
        }));
        navigateTo("grantCapture");
    }

    return (
        <div className="admin-table-container">
            <Table tableData={grantList}
                   onRowClick={handleRowClick}
                   buttonText="Add Grant"
                   onButtonClick={handleAddClick}
                   hiddenColumns={["externalReference", "referenceToExternalSystem", "grantResourceVOs", "isDeleted", "created", "lastModified"]}
            />
        </div>
    );
}
